import { InvoiceDetailPanel } from '@features/invoices/components/detail-panel/InvoiceDetailPanel';
import { useInvoiceAlertsData } from '@features/invoices/contexts/alerts/useInvoiceAlertsData';
import { useInvoiceNavigation } from '@features/invoices/hooks/use-invoice-navigation/useInvoiceNavigation';
import * as React from 'react';
import { useParams } from 'react-router-dom';

const InvoiceDetailRoute = React.memo((): React.ReactElement => {
  const { accountReceivableId } = useParams<{ accountReceivableId: string }>();
  const { navigateToInvoicesList } = useInvoiceNavigation();
  const { closeAlertPanel } = useInvoiceAlertsData();

  React.useEffect(() => {
    closeAlertPanel();
  }, [closeAlertPanel]);

  return (
    <>
      {accountReceivableId && (
        <InvoiceDetailPanel
          onClose={navigateToInvoicesList}
          accountReceivableId={accountReceivableId}
        />
      )}
    </>
  );
});

InvoiceDetailRoute.displayName = 'InvoiceDetailRoute';

export { InvoiceDetailRoute };
